import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=ef195186&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=ef195186&prod&lang=css&"
import style1 from "./edit.vue?vue&type=style&index=1&id=ef195186&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef195186",
  null
  
)

export default component.exports